import { useEffect } from 'react';

import { useFreshRef } from 'src/lib/hooks/useFreshRef';

/**
 * Hook that listens for window resize events
 * @param handler Function to call when window resize is detected
 */
export const useOnWindowResize = (handler: (event: Event) => void): void => {
  const handlerRef = useFreshRef(handler);

  useEffect(() => {
    const resizeHandler = (event: Event): void => {
      if (handlerRef.current) {
        handlerRef.current(event);
      }
    };

    window.addEventListener('resize', resizeHandler);
    return () => window.removeEventListener('resize', resizeHandler);
  }, [handlerRef]);
};
